import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ProfileStepperDialogComponent } from '../../standalone-components/dialogs/profile-stepper-dialog/profile-stepper-dialog.component';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuard implements CanActivate {
  constructor(private authService: AuthService, private dialog: MatDialog) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Verificar primero si hay un token válido
    // Si no hay token válido, dejar que AuthGuard maneje la redirección al login
    if (!this.authService.hasValidToken()) {
      return true;
    }

    const hasProfile = this.authService.userHasProfile();
    const hasBeenOnboarded = this.authService.userHasBeenOnboarded();
    if (hasProfile && hasBeenOnboarded) {
      return true;
    } else {
      this.dialog.open(ProfileStepperDialogComponent, {
        width: '700px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        disableClose: true
      });
      return false;
    }
  }
}
